$(document).ready(function(){
	if(!document.querySelector('.feedback-question')) return false;

	var form = {
		el: document.getElementById('feedbackForm'),
		init: function(){
			checkTextLength($(form.el).find('textarea'), $(form.el).find('.char-count .char-current'));
			form.checkUserStatus();
			form.addEvent();
		},
		checkUserStatus: function(){
			//check browser
			var isie=(/msie/i).test(navigator.userAgent); //ie
			var isie6=(/msie 6/i).test(navigator.userAgent); //ie 6
			var isie7=(/msie 7/i).test(navigator.userAgent); //ie 7
			var isie8=(/msie 8/i).test(navigator.userAgent); //ie 8
			var isie9=(/msie 9/i).test(navigator.userAgent); //ie 9
			var isfirefox=(/firefox/i).test(navigator.userAgent); //firefox
			var isapple=(/applewebkit/i).test(navigator.userAgent); //safari,chrome
			var isopera=(/opera/i).test(navigator.userAgent); //opera
			var isios=(/(ipod|iphone|ipad)/i).test(navigator.userAgent);//ios
			var isipad=(/(ipad)/i).test(navigator.userAgent);//ipad
			var isandroid=(/android/i).test(navigator.userAgent);//android

			if(isie7 || isie8 || isie9){
				isie6=false;
			}
			if(isie9){
				isie=false;
			}

			var device;
			if( /*isapple || */ isios || isandroid){
				device = "Mobile";
			}else if (isipad){
				device = "Tablet";
			}else{
				device = "Pc";
			}

			//check browser
			var a = navigator.userAgent.toLowerCase();
			var b,v;
			if(a.indexOf("safari/") > -1) {
				b = "safari";
				var s = a.indexOf("version/");
				var l = a.indexOf(" ", s);
				v = a.substring(s+8, l);
			}
			if(a.indexOf("chrome/") > -1) {
				b = "chrome";
				var ver = /[ \/]([\w.]+)/.exec(a)||[];
				v = ver[1];
			}
			if(a.indexOf("firefox/") > -1) {
				b = "firefox";
				var ver = /(?:.*? rv:([\w.]+)|)/.exec(a)||[];
				v = ver[1];
			}
			if(a.indexOf("opera/") > -1) {
				b = "opera";
				var ver = /(?:.*version|)[ \/]([\w.]+)/.exec(a)||[];
				v = ver[1];
			}
			if((a.indexOf("msie") > -1) || (a.indexOf(".net") > -1)) {
				b = "ie";
				var ver = /(?:.*? rv:([\w.]+))?/.exec(a)||[];
				if(ver[1])
					v = ver[1];
				else{
					var s = a.indexOf("msie");
					var l = a.indexOf(".", s);
					v = a.substring(s+4, l);
				}
			}

			form.el.device.value = device;
			form.el.browser.value = b;
			form.el.version.value = v;
		},
		addEvent:function(){
			$(form.el).on({
				click : function(e){
					var c = $(form.el).find('.collapse');
					if($(e.currentTarget).is('.toggle-open')) {
						c.collapse('show');
					}else {
						c.collapse('hide');
					}
					var relatedClass = $('.q4-answer-list input[type=radio][data-related-input]').data('related-input');
					if(!$(this).is('[data-related-input]')){
						$(relatedClass).val("");
					}
				}
			}, '.q4-answer-list input[type=radio]');
			// LGEES-161 20210506 Start
			$(form.el).on({
				click : function(e){
					var countryCode = $("html").attr("data-countrycode").toLowerCase();
					if(countryCode == 'es'){

						var queBoxIdx = 0;
						$('.feedback-question-box').each(function(){
							queBoxIdx ++;
							$(this).attr('data-index',queBoxIdx);
						});

						var smileNum = $(this).val(), // select face
							requireStar = $(this).closest('.feedback-question-box').find('.question-q .require').clone(), // star's clone markup
							que3BoxIdx = $(this).closest('.feedback-question-box').attr('data-index'), // Q2 Box index + 1
							que3Box = $('.feedback-question-box:eq(' + que3BoxIdx  + ')'), // Q3 Box
							que3Title = que3Box.find('.question-q'), // Q3 title
							que3Textarea = que3Box.find('.text-area textarea'); // Q3 Textarea

						if(smileNum == '1' || smileNum == '2'){ // select sad face
							if(!que3Title.find('.require').length)
								que3Title.find('.text-num').after(requireStar);
							que3Textarea.prop('required',true);
						}else{
							que3Box.find('.question-q').find('.require').remove();
							que3Box.find('.question-area.field-block').removeClass('error');
							que3Textarea.prop('required',false);
						}

					};
				}
			}, '.face-expression input[type=radio]');
			// LGEES-161 20210506 End
			$(form.el).on({
				validationFail: function(e) {
					//$(form.el).find('.question-a .error-msg > .required').removeAttr('style');
					$(form.el).find('.question-a .field-block').each(function(i, el){
						var inputObj = $(this).find('input[required]');
						if(inputObj.val() == '') { // is it related text input was empty?
							inputObj.parent().next('.error-msg').find('.required').removeAttr('style');
						}else{
							inputObj.parent().next('.error-msg').find('.required').hide();
						}
					}) 
				}
			});
		}
	};

	form.init();
});